/** Angular */
import { InjectionToken } from '@angular/core';

/**
 * The beyond environment configuration injection token
 *
 * @example
 *   {
 *      provide: BYD_TRANSLATE_INJECTION_TOKEN,
 *      useValue: The translate data,
 *   }
 */
export const BYD_TRANSLATE_INJECTION_TOKEN = new InjectionToken('The beyond translate data injection token');
